import React, { useEffect, useState } from "react";
import "./MobileSettings.css";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import { getUserId } from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";
import { debounce } from "lodash";

const MobileSettings = ({ openSide, closeBets }) => {
  const userId = useSelector(getUserId());
  const [defaultStake, setDefaultStake] = useState("");
  const [selectedStakes, setSelectedStakes] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editStakes, setEditStakes] = useState([]);
  const [oddsHighlight, setOddsHighlight] = useState(true);
  const [fancyBetAcceptOdds, setFancyBetAcceptOdds] = useState(true);
  const [sportsBookAcceptOdds, setSportsBookAcceptOdds] = useState(true);
  const [withCommission, setWithCommission] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const allStakes = [10, 30, 50, 100, 200, 300, 500, 1000];

  const defaultSettings = {
    defaultStake: "",
    selectedStakes: [10, 30, 50, 200, 500, 1000],
    editStakes: [10, 30, 50, 100, 200, 300, 500, 1000],
    oddsHighlight: true,
    fancyBetAcceptOdds: true,
    sportsBookAcceptOdds: true,
    withCommission: false,
  };

  useEffect(() => {
    const storageKey = `userSettings`;
    const savedSettings = localStorage.getItem(storageKey);
    let settingsToUse = defaultSettings;
    if (savedSettings) {
      try {
        settingsToUse = JSON.parse(savedSettings);
      } catch (error) {
        console.error("Error parsing localStorage settings:", error);
        alert("Failed to load settings. Using defaults.");
      }
    } else {
      // localStorage.setItem(storageKey, JSON.stringify(defaultSettings));
    }
    settingsToUse = JSON.parse(savedSettings)
    console.log(settingsToUse,"settingsToUse")
    setDefaultStake(settingsToUse?.defaultStake || "");
    setSelectedStakes(settingsToUse?.selectedStakes || defaultSettings?.selectedStakes);
    setEditStakes(settingsToUse?.editStakes || defaultSettings?.editStakes);
    setOddsHighlight(settingsToUse?.oddsHighlight ?? true);
    setFancyBetAcceptOdds(settingsToUse?.fancyBetAcceptOdds ?? true);
    setSportsBookAcceptOdds(settingsToUse?.sportsBookAcceptOdds ?? true);
    setWithCommission(settingsToUse?.withCommission ?? false);
    setIsLoading(false);
  }, []);

  const saveSettings = debounce(() => {
    const settings = {
      defaultStake: Number(defaultStake) || null,
      selectedStakes,
      editStakes,
      oddsHighlight,
      fancyBetAcceptOdds,
      sportsBookAcceptOdds,
      withCommission,
    };
    const storageKey = `userSettings`;
    try {
      localStorage.setItem(storageKey, JSON.stringify(settings));
    } catch (error) {
      console.error("Error saving settings to localStorage:", error);
      alert("Failed to save settings. Please try again.");
    }
  }, 300);

  const handleStakeClick = (stake) => {
    setSelectedStakes((prev) =>
      prev.includes(stake) ? prev.filter((s) => s !== stake) : [...prev, stake]
    );
  };

  const handleEditStakeChange = (index, value) => {
    const numValue = Number.parseInt(value) || 0;
    if (numValue > 0) {
      const newEditStakes = [...editStakes];
      newEditStakes[index] = numValue;
      setEditStakes(newEditStakes);
    }
  };

  const handleEditOk = () => {
    setSelectedStakes([...editStakes]);
    setIsEditMode(false);
    saveSettings();
  };

  const handleCancel = () => {
    const storageKey = `userSettings`;
    const savedSettings = localStorage.getItem(storageKey);
    if (savedSettings) {
      try {
        const settings = JSON.parse(savedSettings);
        setDefaultStake(settings?.defaultStake || "");
        setSelectedStakes(settings?.selectedStakes || defaultSettings.selectedStakes);
        setEditStakes(settings?.editStakes || defaultSettings.editStakes);
        setOddsHighlight(settings?.oddsHighlight ?? true);
        setFancyBetAcceptOdds(settings?.fancyBetAcceptOdds ?? true);
        setSportsBookAcceptOdds(settings?.sportsBookAcceptOdds ?? true);
        setWithCommission(settings?.withCommission ?? false);
      } catch (error) {
        console.error("Error parsing localStorage settings on cancel:", error);
        setDefaultStake(defaultSettings?.defaultStake);
        setSelectedStakes(defaultSettings?.selectedStakes);
        setEditStakes(defaultSettings.editStakes);
        setOddsHighlight(defaultSettings.oddsHighlight);
        setFancyBetAcceptOdds(defaultSettings.fancyBetAcceptOdds);
        setSportsBookAcceptOdds(defaultSettings.sportsBookAcceptOdds);
        setWithCommission(defaultSettings.withCommission);
      }
    }
    setIsEditMode(false);
  };

  const ToggleSwitch = ({ isOn, onToggle, label }) => (
    <button
      onClick={onToggle}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green ${
        isOn ? "bg-green" : "bg-gray"
      }`}
      aria-checked={isOn}
      aria-label={label}
      role="switch"
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform shadow-lg ${
          isOn ? "translate-x-6" : "translate-x-1"
        }`}
      />
    </button>
  );

  if (isLoading) {
    return <div>Loading settings...</div>;
  }

  return (
    <div className={`OpenBets_main ${openSide} h-screen`}>
      <div className="OpenBets_header">
        <div className="OpenBets_image">
          <h4>Settings</h4>
        </div>
        <div className="close-bets cursor-pointer" onClick={closeBets}>
          <IoMdClose />
        </div>
      </div>

      <div className="mx-auto bg-white min-h-screen">
        <div className="bg-[#274050] text-white px-4 py-1">
          <h3 className="font-medium text-md">Stake</h3>
        </div>
        <div className="p-4 border-b border-gray-200">
          <div className="mb-4">
            <label className="block text-sm font-medium text-black mb-2">
              Default Stake
            </label>
            <input
              type="number"
              value={defaultStake}
              onChange={(e) => setDefaultStake(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#444] focus:border-[#444] text-black"
              placeholder="Enter amount"
            />
          </div>
          {!isEditMode ? (
            <div>
              <h4 className="text-sm font-medium text-black mb-3">Quick Stakes</h4>
              <div className="grid grid-cols-4 gap-2 mb-4">
                {selectedStakes.map((stake) => (
                  <button
                    key={stake}
                    className={`h-10 px-3 py-2 rounded-md font-medium text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                      selectedStakes.includes(stake)
                        ? "bg-[#444] text-white focus:ring-[#444]"
                        : "bg-gray-200 text-black border border-gray-300 focus:ring-gray-500"
                    }`}
                    // onClick={() => handleStakeClick(stake)}
                  >
                    {stake}
                  </button>
                ))}
              </div>
              <button
                className="w-full h-10 px-4 py-2 bg-gray-200 border border-gray-300 rounded-md text-black font-medium text-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex items-center justify-center gap-2"
                onClick={() => setIsEditMode(true)}
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
                Edit Stakes
              </button>
            </div>
          ) : (
            <div>
              <h4 className="text-sm font-medium text-black mb-3">Quick Stakes</h4>
              <div className="grid grid-cols-2 gap-2 mb-4">
                {editStakes.map((stake, index) => (
                  <input
                    key={index}
                    type="number"
                    value={stake}
                    onChange={(e) => handleEditStakeChange(index, e.target.value)}
                    className="h-10 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none text-black"
                    min="1"
                  />
                ))}
              </div>
              <button
                className="w-full h-10 px-4 py-2 bg-[#444] hover:bg-[#ff6200] text-white font-medium text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#444]"
                onClick={handleEditOk}
              >
                OK
              </button>
            </div>
          )}
        </div>

        <div className="bg-[#274050] text-white px-4 py-1">
          <h3 className="font-medium text-md">Odds</h3>
        </div>
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-black">Highlight when odds change</span>
            <ToggleSwitch
              isOn={oddsHighlight}
              onToggle={() => setOddsHighlight(!oddsHighlight)}
              label="Highlight when odds change"
            />
          </div>
        </div>

        <div className="bg-[#274050] text-white px-4 py-1">
          <h3 className="font-medium text-md">FancyBet</h3>
        </div>
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-black">Accept Any Odds</span>
            <ToggleSwitch
              isOn={fancyBetAcceptOdds}
              onToggle={() => setFancyBetAcceptOdds(!fancyBetAcceptOdds)}
              label="Accept any odds for FancyBet"
            />
          </div>
        </div>

        <div className="bg-[#274050] text-white px-4 py-1">
          <h3 className="font-medium text-md">SportsBook</h3>
        </div>
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-black">Accept Any Odds</span>
            <ToggleSwitch
              isOn={sportsBookAcceptOdds}
              onToggle={() => setSportsBookAcceptOdds(!sportsBookAcceptOdds)}
              label="Accept any odds for SportsBook"
            />
          </div>
        </div>

        <div className="bg-[#274050] text-white px-4 py-1">
          <h3 className="font-medium text-md">Win Selection Forecast</h3>
        </div>
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-black">With Commission</span>
            <ToggleSwitch
              isOn={withCommission}
              onToggle={() => setWithCommission(!withCommission)}
              label="Include commission in win forecast"
            />
          </div>
        </div>

        <div className="p-4 grid grid-cols-2 gap-3">
          <button
            className="h-12 px-4 py-2 bg-white border border-gray-300 rounded-md text-black font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="h-12 px-4 py-2 bg-[#444] hover:bg-[#ff6200] text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#444]"
            onClick={saveSettings}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileSettings;